module.exports = __webpack_public_path__ + "img/book2.a0117099.png";